module.exports = __webpack_public_path__ + "dc3415ee3e6d7692965bc4002fa9af31.mp4";